// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"902b4dbb","564":"34693fc1"}[chunkId] + ".chunk.js";
};